import { useState, useRef } from 'react';
import { useLanguage } from '../providers/IntlProvider.tsx';
import { Globe } from 'lucide-react';
import { useClickOutside, useLocalStorage } from '../hooks';
import { LANGUAGE_STORAGE_KEY } from '../constants';

const languages = [
  { code: 'ru', name: 'Русский' },
  { code: 'uk', name: 'Українська' },
];

export function LanguageSelector() {
  const { locale, setLocale } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [_, setLocalStorageValue] = useLocalStorage(LANGUAGE_STORAGE_KEY);

  const menuRef = useRef<HTMLDivElement>(null);

  useClickOutside(menuRef, () => setIsOpen(false));

  const selectedLanguage = languages.find((lang) => lang.code === locale);

  return (
    <div className='relative' ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className='flex items-center space-x-1 text-current p-2'
        aria-label='Select language'
      >
        <Globe className='w-5 h-5' />
        <span className='hidden md:inline text-sm'>
          {selectedLanguage?.name}
        </span>
      </button>

      {isOpen && (
        <div className='absolute right-0 mt-2 py-2 w-40 bg-white rounded-lg shadow-lg z-50'>
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => {
                setLocale(language.code);
                setLocalStorageValue(language.code);
                setIsOpen(false);
              }}
              className={`w-full px-4 py-2 text-left hover:bg-gray-100 ${
                locale === language.code
                  ? 'text-blue-600 font-medium'
                  : 'text-gray-700'
              }`}
            >
              {language.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
